export default "__VITE_PUBLIC_ASSET__7bfb9926__"